<template>
    <div>
        <div id="inputGroup" class="input-group input-group-sm">
            <div class="input-group-prepend" :style="getWidth">
                <span class="input-group-text small justify-content-sm-end" id="basic-addon1">{{ prepend }}</span>
            </div>
            <b-form-select v-if="!onlyread" v-model="valueId" :options="itemList" on-change="$emit('input', id)">
                <template v-slot:first>
                    <slot></slot>
                </template>
            </b-form-select>
            <b-form-input v-else type="text" readonly
                          v-model="valueStr"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'InputGroupForm',
        props: {
            prepend: {
                type: String,
                default: ""
            },
            widthPrepend: {
                type: String,
                default: 10
            },
            align: {
                type: String,
                default: ""
            },
            valueId: {
                type: Number,
                default: null
            },
            valueStr: {
                type: String,
                default: ""
            },
            itemList: {
                type: Array,
                default: []
            },
            onlyread: {
                type: Boolean,
                default: false
            }
        },
        created() {
            this.id = this.valueId;
        },
        data() {
            return {
                id: null
            }
        },
        computed: {
            getWidth() {
                return 'flex: 0 0 '+this.widthPrepend+'%;'
            }
        }
    }
</script>

<style>
    #inputGroup .input-group-text {
        width: 100%;
    }
    #basic-addon1 {
        background-color: #3c3f40;
        color: white;
    }
</style>